import { DestroyRef, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as exp from 'node:constants';
import { fromEvent, startWith } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MenuLateralService {
	private readonly destroyRef = inject(DestroyRef);
	public menuLateralViewMode: WritableSignal<'alwaysOpen' | 'alwaysClosed' | 'hoverOpen' | 'hamburgerOpen'> = signal('hoverOpen');
	public isMenuExpanded: WritableSignal<boolean> = signal(false);
	private readonly mobileBreakpoint = 768;

	constructor() {
		const viewMode = this.getTypeFromStorage();
		if (viewMode) {
			this.menuLateralViewMode.set(viewMode);
		}

		fromEvent(window, 'resize')
			.pipe(startWith(null), takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.syncViewModeWithViewport();
			});
	}

	private syncViewModeWithViewport() {
		if (window.innerWidth <= this.mobileBreakpoint) {
			this.menuLateralViewMode.set('hamburgerOpen');
			this.isMenuExpanded.set(false);
			return;
		}

		const viewMode = this.getTypeFromStorage();
		this.menuLateralViewMode.set(viewMode ?? 'hoverOpen');
	}

	getTypeFromStorage(): 'alwaysOpen' | 'alwaysClosed' | 'hoverOpen' | 'hamburgerOpen' | null {
		try {
			return localStorage.getItem('menuLateralViewMode') as 'alwaysOpen' | 'alwaysClosed' | 'hoverOpen' | 'hamburgerOpen' | null;
		} catch (error) {
			console.error('Error getting type from storage:', error);
			return null;
		}
	}

	setIsMenuExpanded(clickEvent: MouseEvent, expanded: boolean) {
		this.isMenuExpanded.set(expanded);
		clickEvent.stopPropagation();
		if (expanded == true && this.menuLateralViewMode() === 'hamburgerOpen') {
			document.addEventListener('click', this.handleOutsideClick);
		}
	}

	private handleOutsideClick = (event: MouseEvent) => {
		const menuElement = document.querySelector('#menuLateral');
		if (menuElement && !menuElement.contains(event.target as Node)) {
			this.isMenuExpanded.set(false);
			document.removeEventListener('click', this.handleOutsideClick);
		}
	};
}
